function getTextWidth(text, font = "13px Poppins, serif") {
    // Cria um elemento canvas temporário
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');
    
    // Define a fonte (usa fonte padrão se não especificada)
    if (font) {
        context.font = font;
    } else {
        // Obtém a fonte computada do body como padrão
        const bodyStyle = window.getComputedStyle(document.body);
        context.font = `${bodyStyle.fontWeight} ${bodyStyle.fontSize} ${bodyStyle.fontFamily}`;
    }
    
    // Mede o texto
    const metrics = context.measureText(text);
    return metrics.width;
}

export default getTextWidth;
